import { render, staticRenderFns } from "./baiguullaga_zar.vue?vue&type=template&id=229fede2&scoped=true&"
import script from "./baiguullaga_zar.vue?vue&type=script&lang=js&"
export * from "./baiguullaga_zar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "229fede2",
  null
  
)

export default component.exports